import axios from 'api';

const config = {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
};

export const getCallCountData = async ({ pageSize, pageIndex, startDate, endDate }) => {
  return axios.get(`api/elastic/call_flow/?page=${pageIndex}&page_size=${pageSize}&start_date=${startDate}&end_date=${endDate}`);
};

export const getCallStatusData = async ({ search, pageSize, pageIndex, date, callType }) => {
  return axios.get(`api/elastic/call_flow/${date}/?search=${search}&page=${pageIndex}&page_size=${pageSize}&call_status=${callType}`);
};

export const getErrorCallMessageData = async ({ callId, date }) => {
  return axios.get(`api/elastic/call_flow/error/${callId}/?date=${date}`);
};

export const reRun = async ({ callId, date }) => {
  return axios.post(`api/elastic/call_flow/call_action/?action_type=rerun`, { call_id: callId, call_date_time: date });
};

export const resume = async ({ callId, date }) => {
  return axios.post(`api/elastic/call_flow/call_action/?action_type=resume`, { call_id: callId, call_date_time: date });
};

export const reRunFeature = async ({ callId, date }) => {
  return axios.post(`api/elastic/call_flow/call_action/?action_type=feature_rerun`, { call_id: callId, call_date_time: date });
};
export const getLobData = () => {
  return axios.get(`api/lob/lob/?get_all=${true}`);
};
export const getTeamsData = () => {
  return axios.get(`api/team/team/?get_all=${true}`);
};
export const getUsersData = () => {
  return axios.get(`api/account/usermanage/?get_all=${true}`);
};
export const modalDataSubmit = async (paramsArray) => {
  var bodyFormData = new FormData();
  paramsArray.forEach((params, index) => {
    bodyFormData.append(`data[${index}][call_date_time]`, params.call_date_time);
    bodyFormData.append(`data[${index}][call_direction]`, params.call_direction);
    bodyFormData.append(`data[${index}][language]`, params.language);
    bodyFormData.append(`data[${index}][lob]`, params.lob);
    if (params.recording_file && params.recording_file.length > 0) {
      bodyFormData.append(`data[${index}][recording_file]`, params.recording_file[0], params.recording_file[0].name);
    }
    bodyFormData.append(`data[${index}][team]`, params.team);
    bodyFormData.append(`data[${index}][user]`, params.user);
  });

  return axios.post(`api/elastic/callflow_call_upload`, bodyFormData, config);
};
